export type JobStatus = '未开始'|'练习中'|'考核中';
// 案例分析-data
export interface DataCaseAnalysis {
  jobName: string;
  knowledge: string;
  jobStatus: JobStatus;
  numberOfAllocations: number;
  id: string;
}
/**  */
export const jobStatusArr: JobStatus[] = ['未开始', '练习中', '考核中'];
export class ClassDataCaseAnalysis {
  jobName = '';

  knowledge = '';

  jobStatus = '未开始';

  numberOfAllocations = 0;

  id = '';
}

export interface Pagination {
  pageNo: number;
  totalRecords: number;
  pageSize: number;
}

export interface CaseAnalysisTable {
  list: DataCaseAnalysis[];
  pagination: Pagination;
}

// 案例作业
export type TJobStatus = '未开始'|'进行中'|'已结束';
/** 作业分配状态 */
export const TJobStatusArr: TJobStatus[] = ['未开始', '进行中', '已结束'];
export interface DataJobView {
  jobName: string;
  className: string;
  pattern: '练习模式'|'考试模式'; // 作业模式
  assignmentModel: 0|1; // 作业模式
  startTime: string;
  endTime: string;
  jobStatus: TJobStatus; // 作业状态
  assignStatus: 0|1|2; // 作业状态
  gradeStatus: 0|1; // 成绩发布状态
  id: string;
}
export class ClassDataJobView {
  jobName='';

  className='';

  pattern= '练习模式';

  assignmentModel= 0;

  startTime='';

  endTime='';

  jobStatus= '未开始';

  assignStatus= 0;

  gradeStatus= 0;

  id='';
}

export interface JobViewTable {
  list: DataJobView[];
  pagination: Pagination;
}

/**
 * @param id
 * @param userId
 * @param userName
 * @param finishStatus 完成状态
 * @param jobScore 分数
 * @param rank 排名
 */
export interface JobDetailListItem {
  id: string;
  userId: string;
  userName: string;
  finishStatus: string; // 完成状态
  jobScore: string; // 分数
  rank: string; // 排名
  pattern: string; // 模式
  assignId?: string; // 分配id
}

export interface JobDetailListTable {
  list: JobDetailListItem[];
  pagination: Pagination;
}
